/* V166 · Collection grid "After Dark · Daylight": the full-width Add to cart button
   runs the card's existing quick add (same popup / add as the old + button).
   No quick add on the card (setting off) -> it opens the product page. */
(function () {
  'use strict';
  if (window.__gobd34) return; window.__gobd34 = true;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-gobd34-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    var card = b.closest('.grid-product');
    var q = card && card.querySelector('.quick-add-btn');
    if (q) q.click(); else if (b.getAttribute('data-url')) location.href = b.getAttribute('data-url');
  });
})();
